/**
 * すべてのCookieをkeyとvalueのペアのオブジェクトとして返す
 */
export const getCookies = () =>
  Object.fromEntries(
    document.cookie
      .split('; ')
      .filter(Boolean)
      .map((cookie) => {
        const [cookieKey, ...cookieValue] = cookie.split('=')
        return [cookieKey, cookieValue.join('=')]
      })
  )

/**
 * 指定したkeyに対応するCookieのvalueを返す
 */
export const getCookieValue = (key) => getCookies()[key]
